import React, { useState, useEffect } from 'react';

import { PlusOutlined, LoadingOutlined } from '@ant-design/icons';
import { Modal, Upload, message } from 'antd';
import { T } from 'react-translator-component';
import styled from 'styled-components';

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const FormWrapper = styled.div`
  width: 870px;
`;

const StationPhotosForm = ({ values, files, setFiles }) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  const [loading, setLoading] = useState(false);

  const handleCancel = () => setPreviewOpen(false);
  const handlePreview = async (file) => {
    if (!file.url) {
      file.url = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url);
    setPreviewOpen(true);
    setPreviewTitle(
      file.name || file.thumbUrl.substring(file.url.lastIndexOf('/') + 1),
    );
  };

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error(T('You can only upload .jpg/.jpeg/.png file!'));
      return false;
    }

    const isLt2M = file.size / 1024 / 1024 < 10;
    if (!isLt2M) {
      message.error(T('Image must smaller than 10MB!'));
      return false;
    }

    if (files.some((f) => f.name === file.name)) {
      message.error(T('An image with this name already exists!'));
      return false;
    } else {
      return true;
    }
  };

  const handleUpdate = async ({ file }) => {
    setLoading(true);
    if (!file.status) {
      setLoading(false);
      return;
    }

    if (file.status === 'done') {
      file.url = await getBase64(file.originFileObj);
      setFiles([...files, file]);
      values.photos.push(file);
    } else if (file.status === 'removed') {
      setFiles(files.filter((item) => item.uid !== file.uid));
      values.photos = values.photos.filter((item) => item.uid !== file.uid);
    } else if (file.status === 'error') {
      message.error(T('Error uploading image!'));
    } else if (file.status === 'uploading') {
      setLoading(true);
      return;
    }

    setLoading(false);
    return;
  };

  const onRemove = (file) => {
    values.deletedPhotos.push(file);
  };

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess('ok');
    }, 0);
  };

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </div>
  );

  return (
    <FormWrapper>
      <Upload
        customRequest={dummyRequest}
        listType='picture-card'
        fileList={files}
        onPreview={handlePreview}
        onChange={handleUpdate}
        beforeUpload={beforeUpload}
        onRemove={onRemove}
        accept='image/png, image/jpeg, image/jpg'
      >
        {files.length >= 3 ? null : uploadButton}
      </Upload>

      <Modal
        visible={previewOpen}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
      >
        <img
          style={{
            width: '100%',
          }}
          src={previewImage}
        />
      </Modal>
    </FormWrapper>
  );
};

export default StationPhotosForm;
